import { useContext } from "react"
import { GetApp } from "../../App"
import { PrintShipViewContext, ShipDataType } from "../../App/Context"
import { BlockField, BlockRow } from "../../Components/Block"
import { PrintListBlock } from "../../Components/PrintListBlock"
import { IUnitDefault } from "../../Types"
import { predefined, PrintShipViewData } from "./Context"
import { PrintShipRigViewProps } from "./Params"

// Mast & rig elements. Detail-level section, only rendered when at least one is present.
export function PrintShipRigView({ data }: PrintShipRigViewProps) {
  const app = GetApp();
  const t = app.getT("ShipDataView");
  const { shipData } = PrintShipViewData.resolveShipData(data);

  const context = useContext(PrintShipViewContext);
  const includeShipDataType = context?.includeShipDataType || ShipDataType.short;
  const visible = !!(includeShipDataType === ShipDataType.details && shipData?.rigElements && shipData.rigElements.length > 0);

  return (
    <PrintListBlock title={t("mast_rig")} visible={visible}>
      {shipData?.rigElements && shipData.rigElements.map((rigElement, index) => (
        <div key={rigElement.id || index}>
          <BlockRow className="block-row-followed-by-block-row">
            <BlockField label={t("rig_element")} className="block-field-150">{rigElement.rigElement ? (predefined.rigElement.includes(rigElement.rigElement) ? t(`rig_${rigElement.rigElement}`) : rigElement.rigElement) : rigElement.rigElement}</BlockField>
            <BlockField label={t("manufacturer")} className="block-field-210">{rigElement.manufacturer}</BlockField>
            <BlockField label={t("model")} className="block-field-150">{rigElement.model}</BlockField>
            <BlockField label={t("serial_number")} className="block-field-150">{rigElement.serialNumber}</BlockField>
            <BlockField label={t("size_height")} className="block-field-75">{rigElement.size} {rigElement.sizeUnit || (rigElement.size ? IUnitDefault.length : "")}</BlockField>
          </BlockRow>
          <BlockRow className="block-row-last">
            <BlockField label={t("place_installation")} className="block-field-150">{rigElement.placeInstallation}</BlockField>
            <BlockField label={t("comment")}>{rigElement.comment}</BlockField>
          </BlockRow>
        </div>
      ))}
    </PrintListBlock>
  );
}
